package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.InviteCodes
import com.evoapps.evoshift.domain.model.InviteDetails
import com.evoapps.evoshift.domain.repository.AuthRepository


class ValidateInviteUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(code: String): Result<InviteDetails> {
        return authRepository.getInviteDetails(InviteCodes.normalize(code))
    }
}
